var map = {
	"./blank/View.vue": "83bf",
	"./carousel/View.vue": "2af0",
	"./embed/View.vue": "5f65",
	"./g2-heatmap/View.vue": "824b",
	"./g2-mix/View.vue": "ffd0",
	"./g2-progress-bullet/View.vue": "15a5",
	"./g2-progress-ring/View.vue": "fd10",
	"./g2-progress-stick/View.vue": "4d4c",
	"./g2-progress-wave/View.vue": "25fb",
	"./g2-relation/View.vue": "b4dc",
	"./params/View.vue": "f0f0",
	"./scroll/View.vue": "f830",
	"./table/View.vue": "9002"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caa1";